import { useState, useRef, useEffect, MutableRefObject } from "react";

const useRect = (): [
  DOMRect | null,
  MutableRefObject<HTMLDivElement | null>
] => {
  const ref = useRef<HTMLDivElement>(null);
  const [rect, setRect] = useState<DOMRect | null>(null);

  const set = () =>
    setRect(ref && ref.current ? ref.current.getBoundingClientRect() : null);

  useEffect(() => {
    set();
    window.addEventListener("resize", set);
    return () => window.removeEventListener("resize", set);
  }, []);

  return [rect, ref];
};

export default useRect;
